/**
 * Application configuration
 */

const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  
  // Feature flags
  FEATURES: {
    ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  },
  
  // API endpoints
  ENDPOINTS: {
    AUTH: '/api/auth',
    CLOSET: '/api/closet',
    CHAT: '/api/chat',
    STYLE: '/api/style',
    OUTFIT: '/api/outfit',
  },
  
  // UI constants
  UI: {
    DRAWER_WIDTH: 240,
    MOBILE_BREAKPOINT: 600,
  }
};

export default config; 